import { Typography } from "@circle-react-uikit/Typography";
import { useNavigate } from "@tanstack/react-router";

import { t } from "@/i18n-js/instance";
import { TippyV2 } from "@/react/components/SettingsApp/CompassCompat/Tooltip";

import { IconButton } from "../../IconButton";
import { MarkAsReadButton } from "./MarkAsReadButton";

export const HeaderUIKit = () => {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-between px-6 pb-2 pt-5">
      <Typography.LabelLg weight="medium">
        {t("header_v3.direct_messages")}
      </Typography.LabelLg>
      <div className="flex items-center justify-end space-x-2">
        <MarkAsReadButton />
        <TippyV2 interactive={false} content={t("new_message")}>
          <IconButton
            name="20-add-lg"
            iconSize={20}
            ariaLabel={t("new_message")}
            onClick={() =>
              void navigate({ to: "/messages/$uuid", params: { uuid: "new" } })
            }
            dataTestId="new-message"
            iconClassName="!text-dark"
          />
        </TippyV2>
      </div>
    </div>
  );
};
